<mat-icon
  class="steam-icon"
  [svgIcon]="'steam-bold'"
></mat-icon>
